import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  showErrorNotification,
  showSuccessNotification,
} from '../services/common';
import { purgeRedisCache } from '../services/qaInternal';
import {
  submitBugFeature,
  updateBugFeatureStatus,
  updateAuthorizedDomain,
  addAuthorizedDomain,
  addSIBDomain,
  updateSIBDomain,
  deleteSIBDomain,
} from 'services/admin';
import {
  LIST_BUG_FEATURE_QUERY_KEY,
  LIST_AUTHORIZED_DOMAINS_QUERY_KEY,
  LIST_SIB_DOMAINS_QUERY_KEY,
} from 'query/admin';

export const usePurgeRedisCache = () => {
  return useMutation(purgeRedisCache, {
    onSuccess: async data => {
      showSuccessNotification(
        `Successfully clean ${data.keysCleaned} keys from redis`,
      );
    },
  });
};

export const useSubmitBugFeature = ({ onSuccess }) =>
  useMutation(submitBugFeature, {
    onSuccess: async res => {
      if (onSuccess) onSuccess();
      showSuccessNotification(
        res?.message || 'successfully submitted bug/feature',
      );
    },
    onError: () => {
      showErrorNotification('failed to submit bug/feature');
    },
  });

export const useUpdateBugFeatureStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(updateBugFeatureStatus, {
    onSuccess: async res => {
      queryClient.invalidateQueries(LIST_BUG_FEATURE_QUERY_KEY);
      showSuccessNotification(`Successfully update status to ${res?.status}`);
    },
    onError: () => {
      showErrorNotification('failed update bug/feature status');
    },
  });
};

export const useAddGSuiteDomain = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  return useMutation(addAuthorizedDomain, {
    onSuccess: async res => {
      queryClient.invalidateQueries(LIST_AUTHORIZED_DOMAINS_QUERY_KEY);
      if (onSuccess) onSuccess();
      showSuccessNotification(
        res?.message || 'successfully added a new GSuite domain',
      );
    },
    onError: () => {
      showErrorNotification('failed to add GSuite domain');
    },
  });
};

export const useUpdateGSuiteCredentials = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  return useMutation(updateAuthorizedDomain, {
    onSuccess: async () => {
      queryClient.invalidateQueries(LIST_AUTHORIZED_DOMAINS_QUERY_KEY);
      if (onSuccess) onSuccess();
      showSuccessNotification(`Successfully GSuite Credentials`);
    },
    onError: () => {
      showErrorNotification('failed update GSuite Credentials');
    },
  });
};

export const useAddSIBDomain = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  return useMutation(addSIBDomain, {
    onSuccess: async res => {
      queryClient.invalidateQueries(LIST_SIB_DOMAINS_QUERY_KEY);
      if (onSuccess) onSuccess();
      showSuccessNotification(
        res?.message || 'Successfully added a new SIB domain',
      );
    },
    onError: () => {
      showErrorNotification('Failed to add SIB domain');
    },
  });
};

export const useUpdateSIBDomain = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  return useMutation(updateSIBDomain, {
    onSuccess: async () => {
      queryClient.invalidateQueries(LIST_SIB_DOMAINS_QUERY_KEY);
      if (onSuccess) onSuccess();
      showSuccessNotification(`Successfully updated SIB Domain`);
    },
    onError: () => {
      showErrorNotification('Failed to update SIB Domain');
    },
  });
};

export const useDeleteSIBDomain = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  return useMutation(deleteSIBDomain, {
    onSuccess: async () => {
      queryClient.invalidateQueries(LIST_SIB_DOMAINS_QUERY_KEY);
      if (onSuccess) onSuccess();
      showSuccessNotification(`Successfully deleted SIB Domain`);
    },
    onError: () => {
      showErrorNotification('Failed to delete SIB Domain');
    },
  });
};
